import axios from "axios";

// Constants
import {
  BASE_URL,
  USE_MOCK_DATA,
  FETCHING_SEARCH_CONFIRM_LOCATIONS,
  FETCHING_SEARCH_CONFIRM_LOCATIONS_SUCCESSFUL,
  FETCHING_SEARCH_CONFIRM_LOCATIONS_FAILED
} from "../../constants";

// =========== ACTION CREATORS - START ==================== //
export function selectTrip({ ...payload }) {
  return { type: "SELECT_TRIP", payload: payload };
}
// Set trip data that is used to populate Reservations/Order Confirmation page
export function setReservedTrip(reservedTrip) {
  return { type: "SET_RESERVED_TRIP", payload: reservedTrip };
}
/**
 * Payload param needs minimum keys of
 * history - to navigate to next page if necessary
 *
 * @param {Object} payload
 */
export function fetchTripById({ history, formValues }) {
  // export function fetchTripById() {
  // history.push("search-results");

  // TESTING ONLY
  if (USE_MOCK_DATA) {
    return function(dispatch) {
      dispatch({ type: "FETCHING_TRIP_BY_ID" });

      var fakeApiPromise = new Promise(resolve => {
        setTimeout(_ => {
          const testData = require("../../../../server/test/mocks/Confirmed_Trip.json");
          resolve(testData);
        }, 300);
      });

      return fakeApiPromise.then(results => {
        dispatch({
          type: "FETCHING_TRIP_BY_ID_SUCCESSFUL",
          payload: results
        });
        history.push("reservations");
      });
    };
  }

  // Production code
  return function(dispatch) {
    dispatch({ type: "FETCHING_TRIP_BY_ID" });

    const url = `${BASE_URL}/reservations`;

    // Fetch trip
    axios
      .post(url, formValues)
      .then(results => {
        dispatch({
          type: "FETCHING_TRIP_BY_ID_SUCCESSFUL",
          payload: results.data
        });
        history.push("reservations");
      })
      .catch(err => {
        // const { status, data } = err.response;
        // var error;
        // if (status === 404) {
        //   error = "We couldn't find the trip.";
        // } else if (status !== 200) {
        //   error = data;
        // }

        dispatch({
          type: "FETCHING_TRIP_BY_ID_FAILURE",
          payload: err.response.data
        });
      });
  };
}

/**
 * Payload param needs minimum keys of
 * history - to navigate to next page if necessary
 *
 * @param {Object} payload
 */
export function fetchDepartingTrips({ history, formValues }) {
  history.push("search-results");

  // TESTING ONLY
  if (USE_MOCK_DATA) {
    return function(dispatch) {
      dispatch({ type: "FETCHING_DEPARTING_TRIPS" });

      var fakeApiPromise = new Promise(resolve => {
        setTimeout(_ => {
          const testData = require("../../../../server/test/mocks/RoundTrip_Departing.json")
            .trips; // Departing + RounTrip
          // const testData = require('../../../../server/test/mocks/RoundTrip_Returning.json').trips // Returning + RounTrip
          resolve(testData);
        }, 300);
      });

      return fakeApiPromise.then(results => {
        dispatch({
          type: "FETCHING_DEPARTING_TRIPS_SUCCESSFUL",
          payload: results
        });
      });
    };
  }

  // Production code
  return function(dispatch) {
    dispatch({ type: "FETCHING_DEPARTING_TRIPS" });

    const url = `${BASE_URL}/flights/departures`;

    // Fetch trips
    axios
      .post(url, formValues)
      .then(results => {
        dispatch({
          type: "FETCHING_DEPARTING_TRIPS_SUCCESSFUL",
          payload: results.data.trips
        });
      })
      .catch(o => {
        dispatch({
          type: "FETCHING_DEPARTING_TRIPS_REJECTED",
          payload: o.response.data // TODO Fix error UI
        });
        // history.push("search-results");
      });
  };
}
/**
 * Payload param needs minimum keys of
 * history - to navigate to next page if necessary
 *
 * @param {Object} payload
 */
export function fetchLocationSuggestions({ history, formValues }) {
  // history.push("location"); // Why not do this right outside where this action is called?
  history.push("location-suggestions");

  // TESTING ONLY
  if (USE_MOCK_DATA) {
    return function(dispatch) {
      dispatch({ type: FETCHING_SEARCH_CONFIRM_LOCATIONS });

      var fakeApiPromise = new Promise(resolve => {
        setTimeout(_ => {
          const testData = require("../../../../server/test/mocks/Location_Suggestions.json");
          resolve(testData);
        }, 300);
      });

      return fakeApiPromise.then(results => {
        dispatch({
          type: FETCHING_SEARCH_CONFIRM_LOCATIONS_SUCCESSFUL,
          payload: results
        });
      });
    };
  }

  // Production code
  return function(dispatch) {
    dispatch({ type: FETCHING_SEARCH_CONFIRM_LOCATIONS });
    const url = `${BASE_URL}/flights/locationsuggestions`;

    // Fetch locations
    axios
      .post(url, formValues)
      .then(results => {
        dispatch({
          type: FETCHING_SEARCH_CONFIRM_LOCATIONS_SUCCESSFUL,
          payload: results.data
        });
        // history.push("location-suggestions");
      })
      .catch(o => {
        dispatch({
          type: FETCHING_SEARCH_CONFIRM_LOCATIONS_FAILED,
          payload: o.response // TODO Fix error UI
        });
        // history.push("search-results");
      });
  };
}

/**
 * Payload param needs minimum keys of
 * history - to navigate to next page if necessary
 *
 * @param {Object} payload
 */
export function fetchReturningTrips({ history, ...payload }) {
  history.push("/search-results/returning");

  // TESTING ONLY
  if (USE_MOCK_DATA) {
    return function(dispatch) {
      dispatch({ type: "FETCHING_RETURNING_TRIPS" });
      // console.log('Debug ppnReturnBundle', ppnReturnBundle)

      var fakeApiPromise = new Promise(resolve => {
        setTimeout(_ => {
          const testData = require("../../../../server/test/mocks/RoundTrip_Returning.json")
            .trips;
          // const testData = require('../../../../server/test/mocks/RoundTrip_Returning.json').trips // Returning + RounTrip
          resolve(testData);
        }, 300);
      });

      return fakeApiPromise.then(results => {
        dispatch({
          type: "FETCHING_RETURNING_TRIPS_SUCCESSFUL",
          payload: results
        });
      });
    };
  }

  // Production code
  return function(dispatch) {
    dispatch({ type: "FETCHING_RETURNING_TRIPS" });

    const url = `${BASE_URL}/flights/returns`;

    // Fetch trips
    axios
      .post(url, payload)
      .then(results => {
        dispatch({
          type: "FETCHING_RETURNING_TRIPS_SUCCESSFUL",
          payload: results.data.trips
        });
      })
      .catch(o => {
        dispatch({
          type: "FETCHING_RETURNING_TRIPS_REJECTED",
          payload: o.response.data // TODO Fix error UI
        });
      });
  };
}

export function fetchInstallmentInfo({ history, ...payload }) {
  // history.push("/customer-info");
  // history.push("/review-order");

  // TESTING ONLY
  if (USE_MOCK_DATA) {
    return function(dispatch) {
      dispatch({ type: "FETCHING_INSTALLMENT_INFO" });

      var fakeApiPromise = new Promise(resolve => {
        setTimeout(_ => {
          const testData = require("../../../../server/test/mocks/InstallmentInfo.json");
          resolve(testData);
        }, 300);
      });

      return fakeApiPromise.then(results => {
        dispatch({
          type: "FETCHING_INSTALLMENT_INFO_SUCCESSFUL",
          payload: results
        });
        history.push("/review-order");
      });
    };
  }

  // Production code
  return function(dispatch) {
    dispatch({ type: "FETCHING_INSTALLMENT_INFO" });

    const url = `${BASE_URL}/flights/contract`;

    // Fetch trips
    axios
      .post(url, payload)
      .then(results => {
        dispatch({
          type: "FETCHING_INSTALLMENT_INFO_SUCCESSFUL",
          payload: results.data
        });
        history.push("/review-order");
      })
      .catch(o => {
        console.log("SOMTO ERR o", o); // Fpr console loggin UI error. Use ErrorBoundary?
        dispatch({
          type: "FETCHING_INSTALLMENT_INFO_REJECTED",
          payload: o.response.data // TODO Fix error UI
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/data/trips/actions.js